// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-checklists-page .sidebar-sticky[data-v-e76e6f82]{position:sticky;top:64px}.test-checklists-page .checklist-section[data-v-e76e6f82]{border-left:3px solid #e0e0e0;padding-left:16px}.test-checklists-page .checklist-item[data-v-e76e6f82]{line-height:1.6}", ""]);
// Exports
module.exports = exports;
